

































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CalcCardSkeleton from "./CalcCardSkeleton.vue";
import { CalcState, CalcStatus } from "@/models/Models";
import { DecimalFormatter } from "@/plugins/strings";
import { CompanyResponse, Driver, ICStickerIcon, InsuranceCard } from "@/services/index.defs";
import { CompanyLogos } from "@/plugins/companyLogos";
import CalcCardLeft from "./CalcCardLeft.vue";
import CalcCardRight from "./CalcCardRight.vue";
import CalcCardPrice from "./CalcCardPrice.vue";
import CalcCardNotes from "./CalcCardNotes.vue";
import { isSameDay } from "date-fns/fp";
import App from "@/App.vue";
import CalcCardCross from "_C/shared/CalcCard/CalcCardCross.vue";
import StarIcon from '@/components/shared/icons/StarIcon.vue';

@Component({
    components: {
        CalcCardSkeleton,
        CalcCardRight,
        CalcCardLeft,
        CalcCardPrice,
        CalcCardNotes,
        CalcCardCross,
        StarIcon,
    }
})
export default class CalcCard extends Vue {
    @Prop({ default: null }) calc: CalcState;
    @Prop({ default: null }) overrideAmount: number;
    @Prop({ default: null }) overrideDate: Date;
    @Prop({ default: null }) crossAmount: number;
    @Prop(Boolean) main: boolean;
    @Prop(Boolean) hideNotes: boolean;
    @Prop(Boolean) hideDecimal: boolean;
    get override(): boolean {
        return this.overrideAmount != this.calc.amount;
    }
    DecimalFormatter = DecimalFormatter;

    get stickerIcon() {
        switch (this.cardSticker?.icon) {
        case ICStickerIcon.Star:
            return StarIcon;
        default:
            return null;
        }
    }

    get stickerStyleConfig() {
        if (!this.cardSticker)
            return null;

        const {
            backgroundColor,
            foregroundColor,
        } = this.cardSticker;

        return {
            backgroundColor,
            color: foregroundColor,
        };
    }

    get cardSticker() {
        const icName = this.calc.insuranceProviderId;
        return this.$store.direct.getters.priorityICSetting?.find((el) => el.name === icName)?.stickerInfo;
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    get providerInfo() {
        const calcProviderId = this.calc.insuranceProviderId;
        const providerList = this.$store.direct.state.dicti.providers;
        if (!Array.isArray(providerList))
            return null;
        return providerList.find((provider) => provider?.code === calcProviderId);
    }

    get step() {
        return this.$store.direct.state.insurance.step;
    }

    get isPrecheck() {
        return this.$route.path.includes("precheck");
    }

    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    get notes(): string[] {
        let notes = [];
        if (this.calc.month > this.card.insuranceMonth) {
            const isYear = this.calc.month == 12;
            const lengthStr = isYear ? `1 год` : `${this.calc.month} месяцев`;
            const note = `Оформление доступно только со сроком страхования на ${lengthStr}`;
            notes.push(note);
        }
        let beginDate;
        if (this.overrideDate) beginDate = this.overrideDate;
        else beginDate = this.calc.beginDate;
        if (!beginDate) return notes;
        if (
            !isSameDay(
                beginDate?.parseDate?.(),
                this.card.beginDate.parseDate()
            )
        ) {
            const dateStr = beginDate.format("PP");
            const note = `Оформление доступно только с датой начала действия полиса: ${dateStr}`;
            notes.push(note);
        }
        return notes;
    }
    @Prop(Boolean) showBuyBtn: boolean;
    @Prop(Boolean) final: boolean;
    get view(): string {
        const br = (this.$root as App).br;
        if (br.width < 620) return "sm";
        if (this.final) return "md";
        if (br.mdAndDown) return "md";
        return "lg";
    }
    get br() {
        return {
            sm: this.view == "sm",
            md: this.view == "md",
            lg: this.view == "lg"
        };
    }

    get showNotes(): boolean {
        return !this.hideNotes && this.notes.length > 0;
    }
    get isLoading(): boolean {
        const readyStatuses = [
            CalcStatus.PreScoringSuccess,
            CalcStatus.Issued,
            CalcStatus.CalcSuccess,
            CalcStatus.CalcFail,
            CalcStatus.NeedToSelectCar
            // CalcStatus.IssueRejected
        ];
        return !readyStatuses.includes(this.calc.status);
    }
    get showCard() {
        const readyStatuses = [
            CalcStatus.Issued,
            CalcStatus.PreScoringSuccess,
            CalcStatus.CalcSuccess
        ];
        return readyStatuses.includes(this.calc.status);
    }
    get crossAmountIsVisible() {
        return (
            this.calc.insuranceProviderId == "astrovolga" && !!this.crossAmount
        );
    }
    get accidentIsVisible() {
        return (
            this.calc.insuranceProviderId == "renaissance" && !!this.crossAmount
        );
    }

    companyLogos = CompanyLogos;

    get driversKbm(): { driver: Driver; kbm: number }[] {
        return this.$store.direct.state.info.driverKbm;
    }

    defaultKbm = 1.17;
    get minKbm(): number {
        if (this.driversKbm.length == 0) return this.defaultKbm;
        const kbms = this.driversKbm.map(x => x.kbm);
        return Math.max.apply(Math, kbms);
    }
    calcAmountDiscount(amount: number): number {
        return amount * (1 - this.minKbm);
    }

    get realPrice(): number {
        return this.overrideAmount && this.override
            ? this.overrideAmount
            : this.calc.amount;
    }
    get price(): string {
        let price = this.calc.amount;
        let decimals = this.hideDecimal ? 0 : 2;
        return `${DecimalFormatter.format(price, decimals, " ", ".")} ₽`;
    }
    get newPrice(): string {
        if (!this.overrideAmount) return null;
        let price = this.overrideAmount;
        return `${DecimalFormatter.format(price, 2, " ", ".")} ₽`;
    }
    /** temporary? */
    @Prop({ type: Boolean, default: () => false }) hideDiscount: boolean;
    @Prop({ type: Boolean, default: () => false })
    hideDiscountOnMobile: boolean;
    @Prop({ default: "Скидка" }) discountText: boolean;
    get displayDiscount() {
        if (this.hideDiscount) return false;
        if (this.hideDiscountOnMobile && (this.$root as any).br.mdAndDown)
            return false;
        return this.calcAmountDiscount(this.calc.amount) > 0;
    }
    /** temporary? end */

    get discount(): string {
        let price = this.calc.amount;
        if (this.overrideAmount && this.overrideAmount > 0)
            price = this.overrideAmount;
        price = this.calcAmountDiscount(price);
        let decimals = this.hideDecimal ? 0 : 2;
        return `${DecimalFormatter.format(price, decimals, " ", ".")} ₽`;
    }
    get provider(): CompanyResponse {
        let icCode = this.calc.insuranceProviderId;
        return this.$store.direct.state.dicti.providers.find(
            x => x.code == icCode
        );
    }

    get logo(): string {
        let companyName = this.provider?.code;
        return companyName ? this.companyLogos[companyName] : null;
    }
}
